import React, {Component} from 'react'
import Field from '../common/Field'
import i18 from '../../i18'
import Validator from '../common/Validator'
import api from '../../source/api'
import PricingData from '../profile/pricingdata'

export default class Payment extends Component {


    constructor(props) {
        super()
        this.state = {
            processing: false,
            balanceInfo: {},
            fields: {
                company_name: {value: '', error: '', role: {required: true}},
                tax_number: {value: '', error: '', role: {required: true}},
                country_id: {value: '', error: '', role: {required: true}},
                postal_code: {value: '', error: '', role: {required: true}},
                city: {value: '', error: '', role: {required: true}},
                address: {value: '', error: '', role: {required: true}},
                amount: {value: '', error: '', role: {required: true}},
            }
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'payment/init'}, true).then((response) => {
            let fields = this.state.fields;

            fields.company_name.value = response.data.billing.company_name
            fields.tax_number.value = response.data.billing.tax_number
            fields.country_id.value = response.data.billing.country_id
            fields.postal_code.value = response.data.billing.postal_code
            fields.city.value = response.data.billing.city
            fields.address.value = response.data.billing.address

            this.setState({
                fields: fields,
                balanceInfo: response.data.balanceInfo
            });
        }).catch((err) => {
            console.log(err);
        }).finally(function () {
            document.body.classList.remove('loading-body')
        });
    }


    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }


    paymentStart = () => {
        if (this.state.processing) return
        document.body.classList.toggle('loading-body', true)
        this.setState({processing: true})
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                processing: false,
                fields: validator.fields
            })
            document.body.classList.remove('loading-body')
            return;
        }

        let data = {
            company_name: this.state.fields.company_name.value,
            tax_number: this.state.fields.tax_number.value,
            country_id: this.state.fields.country_id.value,
            postal_code: this.state.fields.postal_code.value,
            city: this.state.fields.city.value,
            address: this.state.fields.address.value,
            amount: this.state.fields.amount.value,
            redirectUrl: window.location.origin + '/#/payment-success'
        }
        api.post({url: 'payment/start', data: data}, true).then((response) => {
            document.body.classList.remove('loading-body')
            window.location.href = response.data.paymenturl
        }).catch((err) => {
            this.setState({processing: false})
            document.body.classList.remove('loading-body')
        });
    }

    render() {
        return (
            <section id='payment-start'>
                <div className='container'>
                    <div className='row header'>
                        <div className='col-9'>
                            <h1>
                                Egyenleg feltöltése
                            </h1>
                        </div>
                        <div className='col-12'>
                            <p>
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <Field
                                type='number'
                                id='amount'
                                name='amount'
                                label='Feltöltendő egyenleg bruttó (HUF)'
                                classLabel='control-label'
                                classInput='form-control bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </div>
                        <div className='col-lg-5 text-right padding-top-35'>
                            <a onClick={() => this.paymentStart()} className={this.state.processing ? 'disabled next-step margin-top-30' : 'next-step margin-top-30'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._startPayment}</a>
                        </div>
                    </div>
                    <div className='row margin-top-30'>
                        <div className='col-lg-12'>
                            <fieldset>
                                <legend><b>Számlázási adatok:</b></legend>
                                <div className='row '>
                                    <div className='col-md-6'>
                                        <Field
                                            type='text'
                                            id='company_name'
                                            name='company_name'
                                            label='Cégnév'
                                            classLabel='control-label'
                                            classInput='form-control bordered-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>

                                    <div className='col-md-6'>
                                        <Field
                                            type='text'
                                            id='tax_number'
                                            name='tax_number'
                                            label='Adószám'
                                            classLabel='control-label'
                                            classInput='form-control bordered-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>

                                </div>

                                <div className='row margin-top-30'>

                                    <div className='col-md-3'>
                                        <Field
                                            type='text'
                                            id='postal_code'
                                            name='postal_code'
                                            label='Irányítószám'
                                            classLabel='control-label'
                                            classInput='form-control bordered-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <Field
                                            type='text'
                                            id='city'
                                            name='city'
                                            label='Település'
                                            classLabel='control-label'
                                            classInput='form-control bordered-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <Field
                                            type='text'
                                            id='address'
                                            name='address'
                                            label='Utca'
                                            classLabel='control-label'
                                            classInput='form-control bordered-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div>
                        <br/>
                        <PricingData balanceInfo={this.state.balanceInfo}/>
                    </div>
                    <div>
                        <br/>
                        <p className=''>
                            <a href='https://www.barion.com/hu/tajekoztato-biztonsagos-online-fizetesrol' target='_blank'>
                                A szolgáltatást nyújtó Barion Payment Zrt a Magyar Nemzeti Bank felügyelete alatt álló intézmény, <br/>engedélyének száma: H-EN-I-1064/2013.
                            </a>
                        </p>
                    </div>
                    <div className='row margin-top-50'>
                        <div className='col-lg-12 margin-top-50 text-center'>
                            <a onClick={() => this.paymentStart()} className={this.state.processing ? 'disabled next-step margin-top-30' : 'next-step margin-top-30'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._startPayment}</a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/payment/payment.js